import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'È un prodotto fisico o digitale?',
    a: 'È un prodotto 100% digitale (PDF ad alta risoluzione) ottimizzato per la visualizzazione su iPad, Tablet o Smartphone durante i tuoi allenamenti.'
  }, {
    q: 'Funziona per squadre maschili e femminili?',
    a: 'Assolutamente sì. La metodologia proposta è universale e adattabile a qualsiasi categoria o genere.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white py-24 px-4 sm:px-6 lg:px-8" data-id="element-55">
      <div className="max-w-3xl mx-auto" data-id="element-56">
        <div className="text-center mb-16" data-id="element-57">
          <div className="bg-volley-teal/10 text-volley-teal-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-58">
            DOMANDE FREQUENTI (FAQ)
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-volley-dark leading-tight tracking-tight" data-id="element-59">
            Rispondiamo alle{' '}
            <span className="italic text-volley-teal" data-id="element-60">tue domande</span>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-61">
          {faqs.map((faq, idx) => <div key={idx} className="bg-volley-paper rounded-2xl border border-volley-navy/5 overflow-hidden shadow-sm transition-all duration-300" data-id="element-62">
              <button onClick={() => setOpen(open === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left hover:bg-volley-soft transition-colors" data-id="element-63">
                <span className="font-display font-semibold text-volley-navy text-lg sm:text-xl pr-4" data-id="element-64">
                  {faq.q}
                </span>
                <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-300 ${open === idx ? 'bg-volley-orange text-white' : 'bg-volley-teal/10 text-volley-teal-dark'}`} data-id="element-65">
                  {open === idx ? <Minus className="w-4 h-4" data-id="element-66" /> : <Plus className="w-4 h-4" data-id="element-67" />}
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${open === idx ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-68">
                <div className="px-6 pb-6 text-volley-slate text-lg leading-relaxed" data-id="element-69">
                  {faq.a}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}